import commonHelper from '@/app/utility/common.helper.utility';
export default {
  name: 'panBankExcelLoader',
  watch: {
    currentPage: function() {
      this.getPankBankExcelData();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getPankBankExcelData();
    }
  },
  data() {
    return {
      showExcelUploadModal: false,
      fileName: null,
      loader: false,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      totalRows: null,
      currentPage: 1,
      panBankExcelData: [],
      panBankExcelFields: [
        {
          key: 'file_name',
          label: 'File Name',
          class: 'text-center'
        },
        {
          key: 'site_pan_number',
          label: 'Pan Number',
          class: 'text-center'
        },
        {
          key: 'vendor_number',
          label: 'Vendor Number',
          class: 'text-center'
        },
        {
          key: 'bank_name',
          label: 'Bank Name',
          class: 'text-center'
        },
        {
          key: 'account_number',
          label: 'Account Number',
          class: 'text-center'
        },
        {
          key: 'ifsc_code',
          label: 'IFSC Code',
          class: 'text-center'
        },
        {
          key: 'verify_bank_status',
          label: 'Bank Status',
          class: 'text-center'
        },
        {
          key: 'verify_pan_status',
          label: 'Pan Status',
          class: 'text-center'
        },
        {
          key: 'bank_error_msg',
          label: 'Bank Error Message',
          class: 'text-center'
        },
        {
          key: 'pan_error_msg',
          label: 'Pan Error Message',
          class: 'text-center'
        }
      ],
      panBankExcelPayload: null
    };
  },

  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'upload') {
          this.showExcelUploadModal = true;
        }
        if (actionName === 'download') {
          this.loader = true;
          const downloadpayload = { ...this.panBankExcelPayload };
          downloadpayload._limit = this.totalRows;
          this.downloadExcel.downloadData(
            downloadpayload,
            'twoSixASUpload/getPankBankExcelData',
            'PAN BANK VERIFIED DATA',
            () => (this.loader = false)
          );
        }
      }
    });
  },
  methods: {
    getPankBankExcelData() {
      this.panBankExcelPayload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        file_name: this.fileName
      };
      this.loader = true;
      this.$store
        .dispatch(
          'twoSixASUpload/getPankBankExcelData',
          this.panBankExcelPayload
        )
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.panBankExcelData = response.data.data.page;
            this.totalRows = response.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
